import { Routes } from '@angular/router';
import { CustomAuthGuard } from './shared/auth/auth.guard';
import { AuthGuard } from '@auth0/auth0-angular';
import { CidGuard } from './shared/cid/cid.guard';
import { ActorResolver } from './shared/actor/actor.resolver';
import { NotfoundComponent } from './layout/notfound/notfound.component';

export const routes: Routes = [
  {
    path: '', redirectTo: 'dashboard', pathMatch: 'full'
  },
  {
    path: 'login', redirectTo: 'dashboard'
  },
  {
    path: '', loadChildren: () => import('./layout/auth-layout/auth-layout.module').then(m => m.AuthLayoutModule)
  },
  {
    path: '', loadChildren: () => import('./layout/app-layout/app-layout.module').then(m => m.AppLayoutModule),
    canActivate: [CustomAuthGuard, AuthGuard, CidGuard],
    resolve: { actor: ActorResolver }
  },
  {
    path: '**',
    component: NotfoundComponent
  }
];
